export const apps = [
    {
        img: 5,
        app: "Manager Site",
        description: {
            en:'To create and edit your digital menu whenever you need it.',
            es: 'Crea y edita tu menú digital dónde sea que estés.'
        }
    },
    {
        img: 6,
        app: "Reservations",
        description: {
            en:'[EN]',
            es: '[ES]'
        }
    },
    {
        img: 7,
        app: "Survey Creator",
        description: {
            en:'With this tool you will create all the questions that will be applied with DoTell.',
            es: 'Con esta herramienta crearás todas las preguntas que utilizará Dotell'
        }
    },
    {
        img: 4,
        app: "Dotell",
        description: {
            en:'DoTell is the way to apply the surveys you have created to your customers.',
            es: 'Dotell es la herramienta que aplica la encuestas que creaste para tus clientes.'
        }
    },
    {
        img: 2,
        app: "Dashboard",
        description: {
            en:'You will see the results of the questions you have created displayed in this tool.',
            es: 'En esta herramienta visualizarás los resultados de las encuestas que creaste con dotell.'
        }
    },
    {
        img: 8,
        app: "TaskMe",
        description: {
            en:'Take a look at what your team’s tasks are being carried out.',
            es: 'Echa un vistazo a cuáles son las tareas de tu equipo que se están llevando a cabo.'
        }
    },
    {
        img: 0,
        app: "Admin Site",
        description: {
            en:'Always included. Have overall control of the subscribed tools.',
            es: 'Incluída en todos los paquetes. Mantén el control de todas tus herramientas.'
        }
    },
    {
        img: 1,
        app: "Appsinti",
        description: {
            en:'[EN]',
            es: '[ES]'
        }
    },
    {
        img: 3,
        app: "Digital Menu",
        description: {
            en:'The Digital Menu will show everything you have created with the Manager Site.',
            es: 'El menú digital mostrará, mostrará todo lo que creaste con el Manager Site.'
        }
    },
];